// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__2V01y","loader":"styles_loader__2CYsp"};